const consultaAmparos = {
    ObtenerAmparos: 'SICPE/Registro/GetAmparos'
}

const registro = {
    consultaAmparos: consultaAmparos
}

export default registro;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPE/sistema/Registro/Registro.js
// module id = null
// module chunks = 